// 详情列表
<template>
  <div>
    <!-- <Header/> -->
    <Logo></Logo>
    <div><img v-if="this.image != null" :src="image" class="bg"></div>
    <div style="width:43.875rem;margin-left:1.5rem">
        <div class="title">{{list.name}}</div>
        <div class="box_img">
        <el-image v-if="list.cover !== undefined" class="img" :src="list.cover"></el-image>
        </div>
        <div class="box_img">
            <el-tag class="tag">
                <div>
                    功能介绍
                </div>
            </el-tag>
        </div>
        <div class="detail">{{list.content}}</div>
        <div class="email">电子邮箱：{{list.contact_email}}</div>
    </div>
    <div style="height:5.125rem;"><Tabbar></Tabbar></div>
  </div>
</template>

<script>
// import Header from '../../common/FirstHeader.vue'
import Logo from "../Index/Index_components/logo.vue"
import Tabbar from '../Index/Index_components/Tabbar.vue'
import api from '@/utils/api'
export default {
  name: 'servicesDetail',
  components: {
    // Header,
    Logo,
    Tabbar,
  },
  created () {
    this.getDetail()
  },
  methods: {
    async getDetail () {
      const { data: data } = await api.getCategoryOne(this.$route.query.id)
      console.log('具体的产品信息', data.data)
      if (data.code === 200) {
        this.list = data.data
        console.log(this.list)
      }
      if (window.localStorage.getItem('services')) {
        var image1 = JSON.parse(window.localStorage.getItem('services'))
        this.image = image1.data.data.image
      }else{
          const { data:data } = await api.getCategoryImage()
          this.image = data.data.image
      }
    }
  },

  data () {
    return {
      list: [],
      image: null,
    }
  },
}
</script>
<style scoped>
.bg {
  width: 46.875rem;
  height: 14.75rem;
}
.tabbar {
  margin-top: 24.125rem;
}
.img {
  width: 18.75rem;
  height: 21.25rem;
}
.email {
  font-size: 1.5rem;
  color: #999999;
  padding-top: 1.5rem;
  text-align: center;
}
.detail {
  margin-top: 2.25rem;
  font-size: 1.75rem;
  color: #666666;
}
.tag {
  margin-top: 5.75rem;
  /* width: 8.75rem; */
  height: 3rem;
  text-align: center;
  font-size: 1.75rem;
  background: #0099da;
  color: #ffffff;
  line-height: 2.8rem;
}
.title {
  text-align: center;
  color: #333333;
  font-size: 2.125rem;
  margin-top: 4rem;
}
/* 图片设置居中 */
.box_img {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 3.75rem;
}
</style>
